'use client'
import { DynamicWaasEVMConnector } from './DynamicWaasEVMConnector.js';

const DynamicWaasEVMConnectors = () => [DynamicWaasEVMConnector];

export { DynamicWaasEVMConnectors };
